import React, { useCallback } from 'react';
import { fetchDBUDataWithFiltersData } from 'service/service';
import AdbFlatTableBase, { AdbServiceParams } from './AdbFlatTableBase';

/**
 * CostSpendTable component refactored to use AdbFlatTableBase.
 */
const CostSpendTable = () => {
  const serviceFunc = useCallback((params: AdbServiceParams) => {
    const {
      startDate, endDate, env, sector, location,
      page, pageSize, apiFilters, selectedDateInString, exportType,
      sortBy, sortDir
    } = params;
    return fetchDBUDataWithFiltersData({
      startDate,
      endDate,
      env,
      sector,
      location,
      page,
      pageSize,
      filters: apiFilters,
      selectedDateInString,
      workspaceName: undefined,
      exportType,
      sortField: sortBy,
      sortOrder: sortDir
    });
  }, []);

  return (
    <AdbFlatTableBase
      serviceFunc={serviceFunc}
      pageTitle="Cost Spend"
      breadcrumbLabel="Databricks Analysis"
      breadcrumbPath="/databricksADB/workspace"
      tableType="cost-spend-table"
      preserveFilterKey="cost_spend_table"
    />
  );
};

export default CostSpendTable;